import Vue from 'vue';
// TODO Validate states that are stored in local storage to ensure corrupted values can be fixed by refreshing.

const state = {
  project_filters_visible: false,
  project_filters: {
    ...{
      teamMembers: ['All'],
      status: ['All'],
      categoryId: ['All'],
      type: ['All'],
      dates: { start: null, end: null },
    },
    ...JSON.parse(localStorage.getItem('project_filters')),
  },
  search_term: '',
  page: 1,
  perPage: 10,
  orderBy: localStorage.getItem('projects_orderBy') || 'createdAt|DESC',
  total_projects: 0,
  pagination_trigger: 0,
};

const getters = {
  project_filters(state) {
    return state.project_filters;
  },
  project_filters_visible(state) {
    return state.project_filters_visible;
  },
  filters_to_apply(state) {
    return state.filters_to_apply;
  },
  search_term(state) {
    return state.search_term;
  },
  page(state) {
    return state.page;
  },
  perPage(state) {
    return state.perPage;
  },
  orderBy(state) {
    return state.orderBy;
  },
  pagination_trigger(state) {
    return state.pagination_trigger;
  },
  total_projects(state) {
    return state.total_projects;
  },
  project_filters_count(state) {
    let filterCount = 0;
    let filters = JSON.parse(JSON.stringify(state.project_filters));

    // Dates are an object and should be handled differently
    if (filters.dates.start && filters.dates.end) {
      filterCount++;
    }
    delete filters.dates;

    // Filter arrays that contain all aren't filtered
    filterCount += Object.keys(filters)
      .map(key => filters[key].includes('All'))
      .filter(e => e === false).length;
    return filterCount;
  },
};

const mutations = {
  setProjectFilter(state, payload) {
    Vue.set(state.project_filters, payload.key, payload.value);
    localStorage.setItem(
      'project_filters',
      JSON.stringify(state.project_filters)
    );
  },
  setProjectFilters(state, payload) {
    state.project_filters = payload;
    localStorage.setItem(
      'project_filters',
      JSON.stringify(state.project_filters)
    );
  },
  resetProjectFilters(context) {
    state.project_filters = {
      teamMembers: ['All'],
      status: ['All'],
      categoryId: ['All'],
      type: ['All'],
      dates: { start: null, end: null },
    };
  },
  setProjectFiltersVisible(state, payload) {
    state.project_filters_visible = payload;
  },
  setSearchTerm(state, payload) {
    state.search_term = payload;
  },
  setPage(state, payload) {
    state.page = payload;
  },
  setPerPage(state, payload) {
    state.perPage = payload;
  },
  setOrderBy(state, payload) {
    state.orderBy = payload;
    localStorage.setItem('projects_orderBy', payload);
  },
  incrementPaginationTrigger(state, payload) {
    state.pagination_trigger++;
  },
  setTotalProjects(state, payload) {
    state.total_projects = payload;
  },
};

const actions = {
  setProjectFilter(context, payload) {
    context.commit('setProjectFilter', payload);
  },
  setProjectFilters(context, payload) {
    context.commit('setProjectFilters', payload);
  },
  resetProjectFilters(context) {
    context.commit('resetProjectFilters');
  },
  setProjectFiltersVisible(context, payload) {
    context.commit('setProjectFiltersVisible', payload);
  },
  setSearchTerm(context, payload) {
    context.commit('setSearchTerm', payload);
  },
  setPage(context, payload) {
    context.commit('setPage', payload);
  },
  setPerPage(context, payload) {
    context.commit('setPerPage', payload);
  },
  setOrderBy(context, payload) {
    context.commit('setOrderBy', payload);
  },
  incrementPaginationTrigger(context) {
    context.commit('incrementPaginationTrigger');
  },
  setTotalProjects(context, payload) {
    context.commit('setTotalProjects', payload);
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
